import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { ReactNode } from "react";
import { AuthProvider } from "./authBackoffice";
import { NotificationProvider } from "./notification";

// Aqui, PropsWithChildren define que o componente espera a propriedade children
export const Hooks: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <AuthProvider>
      <NotificationProvider>
      <QueryClientProvider client={new QueryClient()}>{children}</QueryClientProvider>
      </NotificationProvider>
    </AuthProvider>
  );
};
